export const normalizeIsoString = (value?: string | null) => {
  if (!value) return value ?? undefined;

  const trimmed = value.trim();
  if (!trimmed) return undefined;

  // Handle redundant timezone suffix like +00:00Z
  if (trimmed.endsWith("+00:00Z")) {
    return trimmed.replace("+00:00Z", "Z");
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return `${trimmed}T00:00:00Z`;
  }

  return trimmed;
};

export const parseNormalizedDate = (value?: string | null) => {
  const normalized = normalizeIsoString(value);
  if (!normalized) return null;
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
